
import { defineComponent, defineAsyncComponent } from "vue";

export default defineComponent({
  components: {
    Header: defineAsyncComponent(() => import("@/components/nav/Header.vue")),
    Footer: defineAsyncComponent(() => import("@/components/nav/Footer.vue")),
  },
});
